"use strict";

exports.__esModule = true;
exports.UnitSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Selector = require("../../Core/Selector");
var _Catalogs = require("../../../Catalogs");
var _excluded = ["items"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getKey = function getKey(input) {
  return input;
};
var renderItemText = function renderItemText(input) {
  return input;
};
var renderItemLabel = function renderItemLabel(input) {
  var definition = (0, _Catalogs.getUnitDefinition)(input);
  return definition.symbol;
};
var itemPredicate = function itemPredicate(query, units) {
  var q = query.toLowerCase();
  var definition = (0, _Catalogs.getUnitDefinition)(units);
  return units.toLowerCase().indexOf(q) !== -1 || definition.description.toLowerCase().indexOf(q) !== -1;
};

/**
 * Allows a user to select measurement units from a list.
 */
var UnitSelector = exports.UnitSelector = function UnitSelector(_ref) {
  var items = _ref.items,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
    items: items || _Catalogs.unitDefinitions.map(function (item) {
      return item.name;
    }),
    placeholder: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UnitSelector.placeholder",
      defaultMessage: "Select Units"
    }),
    getKey: getKey,
    renderItemText: renderItemText,
    renderItemLabel: renderItemLabel,
    itemPredicate: itemPredicate,
    width: 275
  }, extra));
};